import React, { useCallback, useEffect, useState } from 'react'
import { DocumentsProvider } from 'app/react/components/documents/DocumentsContext'
import { debounce } from 'lodash'
import { useFirstRender } from 'app/react/hooks/useFirstRender'
import useScroll from 'app/react/hooks/useScroll'

export default function DocumentsContainer ({
  children,
  restUrl = '',
  headerTitle = '',
  categories = [],
  texts,
}) {

  const [page, setPage] = useState(1)
  const [search, setSearch] = useState(0)
  const [currentCategories, setCurrentCategories] = useState(categories[0]?.termId ?? 0)
  const [documents, setDocuments] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [postsPerPage, setPostsPerPage] = useState(0)
  const [containerRef, setContainerRef] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isSearchLoading, setIsSearchLoading] = useState(false)

  const setDebouncedSearch = useCallback(debounce((e) => {
    setSearch(e.target.value)
    setPage(1)
  }, 500), [])

  const firstRender = useFirstRender()
  const { scrollTo } = useScroll()

  const fetchDocuments = () => {
    setIsLoading(true)
    fetch(restUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        's': search,
        'category': currentCategories
      })
    })
      .then(response => response.json())
      .then(response => {
        setDocuments(response.posts)
        setTotalPages(response.totalPages)
        setPostsPerPage(response.postsPerPage)
        setIsLoading(false)
        setIsSearchLoading(false)
      })
  }

  useEffect(() => {
    fetchDocuments()
  }, [currentCategories, search])

  useEffect(() => {
    if (firstRender) {
      return
    }

    if (containerRef?.current) {
      scrollTo(containerRef.current.getBoundingClientRect().top)
    }
  }, [page])

  return (
    <DocumentsProvider value={{
      headerTitle,
      categories,
      texts,
      search,
      setDebouncedSearch,
      currentCategories,
      setCurrentCategories,
      documents,
      setDocuments,
      page,
      setPage,
      totalPages,
      postsPerPage,
      containerRef,
      setContainerRef,
      isLoading,
      isSearchLoading,
      setIsSearchLoading
    }}>
      {children}
    </DocumentsProvider>
  )
}
